import { render } from "./BaseSwitch.vue?vue&type=template&id=3ddfc0b2&scoped=true"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"

import "./BaseSwitch.vue?vue&type=style&index=0&id=3ddfc0b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddfc0b2"]])

export default __exports__